var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsbDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.3125C1.50391 1.3125 1.3125 1.53125 1.3125 1.75V7C1.3125 7.24609 1.50391 7.4375 1.75 7.4375H10.9375V1.3125H1.75ZM0 1.75C0 0.792969 0.765625 0 1.75 0H11.375C11.8398 0 12.25 0.410156 12.25 0.875V7.875C12.25 8.36719 11.8398 8.75 11.375 8.75H1.75C0.765625 8.75 0 7.98438 0 7V1.75ZM16.625 0.875C17.0898 0.875 17.5 1.28516 17.5 1.75V7C17.5 7.49219 17.0898 7.875 16.625 7.875H13.125V0.875H16.625ZM15.3125 2.40625C14.9297 2.40625 14.6562 2.70703 14.6562 3.0625C14.6562 3.44531 14.9297 3.71875 15.3125 3.71875C15.668 3.71875 15.9688 3.44531 15.9688 3.0625C15.9688 2.70703 15.668 2.40625 15.3125 2.40625ZM14.6562 5.6875C14.6562 6.07031 14.9297 6.34375 15.3125 6.34375C15.668 6.34375 15.9688 6.07031 15.9688 5.6875C15.9688 5.33203 15.668 5.03125 15.3125 5.03125C14.9297 5.03125 14.6562 5.33203 14.6562 5.6875Z",
    fill: "#0047D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbDrive);
export default __webpack_public_path__ + "static/media/usb-drive.7ab8888713de94cc625822820a85d986.svg";
export { ForwardRef as ReactComponent };